import axios from 'axios';
const bookingAxiosApi = axios.create({
  baseURL: process.env.REACT_APP_BOOKING_API_BASE_URL,
  headers: {
    apikey: process.env.REACT_APP_BOOKING_API_KEY,
    clientkey: process.env.REACT_APP_BOOKING_API_CLIENT_KEY,
    'Content-Type': 'application/json',
  },
});

// Optional: add token interceptor
// branchAxiosaApi.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

export default bookingAxiosApi;
